module.exports = __webpack_public_path__ + "assets/icons/baseline-brightness_5-24px-fbd2.svg";